
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail",
      function () {
        return require("private-next-pages/mail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mail"])
      });
    }
  